import { RootState } from "@/store"

const selectConnectionStatus = () => (state: RootState) =>
  state.realtime.connectionStatus
const selectRealtimeError = () => (state: RootState) => state.realtime.lastError
const selectMovementTerminal = () => (state: RootState) =>
  state.realtime.movementTerminal

export const RealtimeSelectors = {
  selectConnectionStatus,
  selectRealtimeError,
  selectMovementTerminal
}
